import React, { createContext, useContext, useEffect, useState } from 'react';
import { isMobileScreen, isMobileScreenDropdown } from '../utils/utils';

export const viewportContext = createContext({});

const ViewportProvider = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [isMobileScreenCheck, setIsMobileScreenCheck] = useState(false);

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
    setIsMobileScreenCheck(isMobileScreenDropdown());
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return <viewportContext.Provider value={{ width, height, isMobileScreenCheck }}>{children}</viewportContext.Provider>;
};

type ViewportContext = {
  width?: any;
  height?: any;
  isMobileScreenCheck?: boolean;
};

const useViewport = () => {
  const { width, height, isMobileScreenCheck } = useContext<ViewportContext>(viewportContext);
  return { width, height, isMobileScreenCheck };
};

export { useViewport };
export default ViewportProvider;
